module.exports = __webpack_public_path__ + "img/mergdata_banner.dd03fdb1.png";